import React, { Fragment, useState } from "react";
import "../../../css/custom.css";
import { Card, CardBody, Button, Form, FormGroup, Label, Input, Alert } from "reactstrap";
import { useDispatch } from "react-redux";
import { Adddepression } from "./store";
import { Link, useNavigate } from "react-router-dom";
import { AesDecrypt } from "../../../services/crypto";
import { useTranslation } from 'react-i18next';
import BreadCrumbs from "../../breadcrumbs";
import Swal from "sweetalert2";

const Depression = () => {
  const dispatch = useDispatch();
  const [depression, setDepression] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedChoice, setSelectedChoice] = useState("");
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userId = localStorage.id;

  const handleChoiceSelection = (choice) => {
    setSelectedChoice(choice);
    setError("");
  };

  const handleNextQuestion = (e) => {
    e.preventDefault();
    if (!selectedChoice) {
      setError(t("Please select an option"));
      return;
    }
    const currentQuestion = depressionQuestions[currentQuestionIndex].id;
    setDepression((prevMood) => ({ ...prevMood, [currentQuestion]: selectedChoice }));
    setSelectedChoice(depression[depressionQuestions[currentQuestionIndex + 1]?.id] || "");
    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
  };

  const handlePreviousQuestion = (e) => {
    e.preventDefault();
    setError(""); // Clear any existing error
    setSelectedChoice(depression[depressionQuestions[currentQuestionIndex - 1].id] || "");
    setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
  };

  const handleSaveMood = (e) => {
    e.preventDefault();
    if (!selectedChoice) {
      setError(t("Please select an option"));
      return;
    }
    const currentQuestion = depressionQuestions[currentQuestionIndex].id;
    const DepressionData = { ...depression, [currentQuestion]: selectedChoice };
    const data = { userId, depression: DepressionData };

    dispatch(Adddepression(data)).then((response) => {
      const Response = response.payload.response;
      if (Response === "S") {
        Swal.fire({
          title: t("Depression Test Successful"),
          icon: "success",
        });
        navigate('/mentalhealth');
      }
    });
    setDepression({});
    setSelectedChoice("");
    setCurrentQuestionIndex(0);
  };

  const depressionQuestions = [
    { id: "d1", question: t("1.Little interest or pleasure in doing things") },
    { id: "d2", question: t("2.Feeling down, depressed or hopeless") },
    { id: "d3", question: t("3.Trouble falling asleep, staying asleep, or sleeping too much") },
    { id: "d4", question: t("4.Feeling tired or having little energy") },
    { id: "d5", question: t("5.Poor appetite or overeating") },
    { id: "d6", question: t("6.Feeling bad about yourself - or that you’re a failure or have let yourself or your family down") },
    { id: "d7", question: t("7.Trouble concentrating on things, such as reading the newspaper or watching television") },
    { id: "d8", question: t("8.Moving or speaking so slowly that other people could have noticed. Or, the opposite - being so fidgety or restless that you have been moving around a lot more than usual") },
    { id: "d9", question: t("9.Thoughts that you would be better off dead or of hurting yourself in some way") }
  ];

  const commonChoices = [
    { label: t("Not at all"), value: "0" },
    { label: t("Several days"), value: "1" },
    { label: t("More than half the days"), value: "2" },
    { label: t("Nearly every day"), value: "3" }
  ];

  const isLastQuestion = currentQuestionIndex === depressionQuestions.length - 1;
  const isFirstQuestion = currentQuestionIndex === 0;

  return (
    <Fragment>
      <BreadCrumbs title={t('Depression')} data={[{ title: t('Depression') }]} />

      <span className="mentalhealth text-black">{t('Over the last 2 weeks, how often have you been bothered by the following problems?')}</span>

      <div></div>
      <Card style={{ marginTop: "2%", boxShadow: "0px 0px 10px 5px rgb(144 144 144 / 56%)" }}>
        <CardBody>
          <Form onSubmit={isLastQuestion ? handleSaveMood : handleNextQuestion}>
            <FormGroup tag="fieldset" >
              <legend className="text-black" style={{ fontSize: "30px" }}>{depressionQuestions[currentQuestionIndex].question}</legend>
              {commonChoices.map((choice, i) => (
                <FormGroup className="text-black" check key={i}>
                  <Label check>
                    <Input
                      type="checkbox"
                      className="form-check-input mb-4"
                      value={choice.value}
                      checked={selectedChoice === choice.value}
                      onChange={() => handleChoiceSelection(choice.value)}
                    />
                    {choice.label}
                  </Label>
                </FormGroup>
              ))}
            </FormGroup>
            {error && <Alert color="danger">{error}</Alert>}
            <div style={{display:'flex',justifyContent:'flex-end'}}>
              {!isFirstQuestion && (
                <Button color="secondary" onClick={handlePreviousQuestion} style={{ marginRight: "10px" }}>
                  {t('Previous')}
                </Button>
              )}
              <Button style={{ width: 'auto' }} color="primary" type="submit" className="small-button"  >
                {isLastQuestion ? t('Save') : t('Next')}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default Depression;
